import React, {useState} from "react";
import {useError} from "../../hooks/useError";
import {Toast, ToastBody, ToastContainer} from "react-bootstrap";

export function ErrorToast() {

    const {setErrorMessage, errorMessage} = useError();
    const [show, setShow] = useState(errorMessage != null && errorMessage !== "");

    if(errorMessage != null) {
        return (
            <ToastContainer position={"bottom-end"} className={"p-3 "}>

                <Toast className={" align-items-center "} show={show} onClose={() => {
                    setShow(false)
                    setErrorMessage(null)
                }} autohide={true} delay={4000} role="alert" aria-live="assertive" aria-atomic="true">
                    <Toast.Header closeButton={true} className={"bg-danger text-white"}>
                        <strong className="me-auto">Feil</strong>
                    </Toast.Header>
                    <ToastBody>
                        {errorMessage}
                    </ToastBody>
                </Toast>
            </ToastContainer>

        );
    }

}